import { render, staticRenderFns } from "./chosen-topic.vue?vue&type=template&id=594d4224&scoped=true"
import script from "./chosen-topic.vue?vue&type=script&lang=js"
export * from "./chosen-topic.vue?vue&type=script&lang=js"
import style0 from "./chosen-topic.vue?vue&type=style&index=0&id=594d4224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594d4224",
  null
  
)

export default component.exports